"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.greeting = void 0;
const greeting = (greet, name) => {
    return `${greet}, ${name}!`;
};
exports.greeting = greeting;
//# sourceMappingURL=greeting.js.map